var BaseViews = require('../base');
var MenuProductEntities = require('../menu/menu-product');
var ProductVendorEntities = require('../../admin-app/entities/product-vendor');
require('./search-modal/search-modal.scss');

var SearchModal = BaseViews.LayoutView.extend({
    _menuState: null,
    _menuItemCategories: null,
    className: 'fmcy-search-modal fmcy-plugin-bootstrap',
    template: require('./search-modal/search-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                isUserLoggedIn: false,
                customerData: null,
                _appChannel: null,
                _menuState: null,
                algolia: null,
                searchType: 'product' //product, vendor...
            }
        );

        self._menuState = self.options._menuState;
        self._menuItemCategories = self._menuState.get('menuItemCategories');
        
        // Listen for fallback to legacy vendor search
        if (this.options._appChannel) {
            this.listenTo(this.options._appChannel, 'use:legacy:vendor:search', this._renderLegacyVendorSearch);
        }
    },
    regions: {
        searchRegion: '.fmcy-search-region',
    },
    ui: {
      searchMenuWrapper: '.fmcy-search-menu-wrapper',
      searchMenuInnerArea: '.fmcy-search-menu-inner-area'
    },
    _renderSearch: function () {
      if (this.options.algolia.search_enabled) {
        var AlgoliaAutocomplete = require('./algolia-autocomplete');
        if (this.options.algolia.disable_analytics) {
          console.log('Algolia Analytics Disabled');
        }
        this.autocompleteView = new AlgoliaAutocomplete({
            _appChannel: this.options._appChannel,
            indexName: this.options.algolia.indexName,
            algoliaAppId: this.options.algolia.appId,
            algoliaSearchApiKey: this.options.algolia.searchApiKey,
            disableAnalytics: this.options.algolia.disable_analytics
        });
        this.searchRegion.show(this.autocompleteView);
      } else {
        this._renderLegacySearch();
      }
    },
    _renderLegacySearch: function () {
      var DropdownListInner = require('treeline-shared-components/dropdown-list/dropdown-list-inner.js');
      var self = this;
      var productsCollection =
          new MenuProductEntities.PageableMenuProductsCollection(null, {
            productCategories: self._menuItemCategories,
            queryParams: {
                remove_out_stock_variation: false,
                customer_ordering: true
            }
          });
      var list = new DropdownListInner({
          collection: productsCollection,
          displayAttr: 'searchTitle',
          valueAttr: 'id',
          iconURLAttr: 'preview_image',
          placeholder: 'What are you looking for?',
          allowClear: true,
          width: '100%',
          openAndFocused: true,
          closeOnSelect: false,
          dropdownCssClass: 'fmcy-menu-search-dropdown',
          minimumResultsForSearch: 3,
          minimumInputLength: 1,
          inputTooShortMessage: 'Enter a product name or brand',
          onSelectedCallback: function (val, model) {
              if (model) {
                  self.options._appChannel.request(
                      'load:product:url',
                      model.get('slug')
                  );
                  self.options._appChannel.trigger('menu:search:view:close');
              }
          }
      });

      list.listenTo(self._menuState, 'change:displayedProduct', function () {
          if (!self._menuState.get('displayedProduct')) {
              list.val('');
          }
      });
      this.searchRegion.show(list);
    },
    _renderVendorSearch: function () {
      var self = this;
      
      // Log the Algolia settings to debug
      console.log('Algolia vendor search settings:', {
        algoliaConfig: this.options.algolia,
        vendor_search_enabled: this.options.algolia && this.options.algolia.vendor_search_enabled
      });
      
      // First check if vendor search is enabled specifically
      if (this.options.algolia && 
          this.options.algolia.search_enabled && 
          this.options.algolia.vendor_search_enabled === true && 
          this.options.algolia.appId && 
          this.options.algolia.searchApiKey &&
          this.options.algolia.indexName) {
          
        var AlgoliaVendorSearch = require('./algolia-vendor-search');
        this.vendorSearchView = new AlgoliaVendorSearch({
          _appChannel: this.options._appChannel,
          indexName: this.options.algolia.indexName,
          algoliaAppId: this.options.algolia.appId,
          algoliaSearchApiKey: this.options.algolia.searchApiKey,
          disableAnalytics: this.options.algolia.disable_analytics || false,
          // Use the vendor_search_enabled setting from PHP
          vendorSearchEnabled: true
        });
        
        try {
          this.searchRegion.show(this.vendorSearchView);
        } catch (error) {
          console.error('Error showing AlgoliaVendorSearch view:', error);
          this._renderLegacyVendorSearch();
        }
      } else {
        // Use legacy vendor search if Algolia vendor search is not enabled or misconfigured
        console.log('Using legacy vendor search due to settings or configuration');
        this._renderLegacyVendorSearch();
      }
    },
    _renderLegacyVendorSearch: function () {
      var self = this;
      var vendorCollection = new ProductVendorEntities.PageableProductVendorsCollection(self.options._appChannel.request('get:vendors').toJSON(), {
                queryParams: {
                    filterHideOnMenuFilter: true,
                    filterOutOfStock: true
                }
            });

      self.vendorDropdownList = new (require('treeline-shared-components/dropdown-list/dropdown-list-inner'))({
                    collection: vendorCollection,
                    dropdownCssClass: 'fmcy-menu-search-dropdown',
                    suppressSearch: false,
                    width: '100%',
                    openAndFocused: true,
                    inputFocused: false,
                    displayAttr: 'name',
                    iconURLAttr: 'image_thumb_url_light_theme',
                    valueAttr: 'id',
                    allowClear: true,
                    placeholder: 'Select Brand',
                    onSelectedCallback: function (vendorId, model) {
                      self.options._appChannel.trigger(
                          'search:options:changed',
                          {
                              categorySlug: 'all',
                              subCategorySlug: 'all',
                              filterVendor: vendorId
                          }
                      );
                      self.options._appChannel.trigger('menu:search:view:close');
                    }
                });
      this.searchRegion.show(self.vendorDropdownList);
    },
    _onWindowResize: function (event) {
      if ($(window).width() > 1100) {
        var rightPos = (($(window).width() - 1100) / 2);
        this.ui.searchMenuWrapper.css('right', rightPos);
        this.ui.searchMenuInnerArea.css('width', 410);
      } else {
        this.ui.searchMenuWrapper.css('right', 0);
        this.ui.searchMenuInnerArea.css('width', $(window).width());
      }
    },
    serializeData: function () {
      var displayName = null;

      if (this.options.customerData !== null) {
        displayName = this.options.customerData.get('display_name');
      }

      return {
        rootUrl: window.location.protocol + '//' + window.location.hostname,
        isUserLoggedIn: this.options.isUserLoggedIn,
        displayName: displayName
      }
    },
    onRender: function() {
      var self = this;
      if (this.options.searchType == 'vendor') {
        this._renderVendorSearch();
      } else {
        this._renderSearch();
      }
      this._onWindowResize();
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = SearchModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/search/search-modal.js
 **/